import React, { FC } from 'react';

import { Spinner } from 'src/components/spinner';

export const PageLogout: FC = () => <Spinner />;
